// /******/ (() => { // webpackBootstrap
// var __webpack_exports__ = {};
// window.PXUTheme.jsFeaturedCollection = {
//   init: function($section) {

//     // Add settings from schema to current object
//     window.PXUTheme.jsFeaturedCollection = $.extend(this, window.PXUTheme.getSectionData($section));

//     if(this.enable_masonry_layout && !this.align_height && this.collection_style == 'grid') {
//       window.PXUTheme.applyMasonry();
//     }

//     if(this.collection_style == 'slider') {
//       this.createSlider();
//     }


//   },
//   createSlider: function() {

//     let featuredCollectionSlider = $('.featured-collection.layout--slider .slider-gallery');

//     const slideData = {
//       products_per_slide: this.products_per,
//       products_available: this.products_available,
//       products_limit: this.products_limit,
//       cellAlign: "left",
//       wrapAround: true
//     }

//     $(featuredCollectionSlider).flickity({
//       lazyLoad: 2,
//       freeScroll: true,
//       imagesLoaded: true,
//       draggable: true,
//       cellAlign: 'left',
//       wrapAround: slideData.wrapAround,
//       pageDots: false,
//       contain: true,
//       prevNextButtons: slideData.products_limit > slideData.products_per_slide ? true : false,
//       initialIndex: 0,
//       arrowShape: arrowShape,
//       on: {
//         ready: function() {
//           // Resize flickity when the slider is settled
//           $(featuredCollectionSlider).on( 'settle.flickity', function() {
//             $(featuredCollectionSlider).flickity('resize')
//           });
//         }
//       }
//     });
  
//     $section.find('.fc-prev').on('click', function () {
//       $section.find('.slider-gallery .flickity-button.previous').trigger('click');
//     });

//     $section.find('.fc-next').on('click', function () {
//       $section.find('.slider-gallery .flickity-button.next').trigger('click');
//     });


//   },
//   unload: function($section) {
//     let $slider = $section.find('.flickity-enabled');
//     $slider.flickity('destroy');
//   }
// }

// /******/ })()
// ;


/******/ (() => {
var __webpack_exports__ = {};
window.PXUTheme.jsFeaturedCollection = {

  init: function($section) {

    this.$section = $section;
    window.PXUTheme.jsFeaturedCollection = $.extend(this, window.PXUTheme.getSectionData($section));

    if (this.enable_masonry_layout && !this.align_height && this.collection_style == 'grid') {
      window.PXUTheme.applyMasonry();
    }

    if (this.collection_style == 'slider') {
      this.createSlider($section);
    }
  },

  createSlider: function($section) {

    let $slider = $section.find('.slider-gallery');

    $slider.flickity({
      lazyLoad: 2,
      freeScroll: true,
      imagesLoaded: true,
      draggable: true,
      cellAlign: 'left',
      wrapAround: true,
      pageDots: false,
      contain: true,
      prevNextButtons: true,
      initialIndex: 0,
      arrowShape: arrowShape,
      on: {
        ready: function () {

          // External arrows → internal Flickity arrows
          $section.find('.fc-prev').on('click', function () {
            $slider.find('.flickity-button.previous').trigger('click');
          });

          $section.find('.fc-next').on('click', function () {
            $slider.find('.flickity-button.next').trigger('click');
          });
        }
      }
    });
  },

  unload: function($section) {
    let $slider = $section.find('.flickity-enabled');
    $slider.flickity('destroy');
  }
}
})();
